import { render, staticRenderFns } from "./storesList.vue?vue&type=template&id=3d5f1312&"
import script from "./storesList.vue?vue&type=script&lang=js&"
export * from "./storesList.vue?vue&type=script&lang=js&"
import style0 from "./storesList.vue?vue&type=style&index=0&id=3d5f1312&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports